<template>
  <v-container class="mb-12">
    <v-flex>
      <v-layout justify-center>
        <Logo></Logo>
      </v-layout>

      <h1 class="text-center mb-4">FAQs</h1>

      <v-expansion-panels
          v-model="panel"
      >
        <v-expansion-panel>
          <v-expansion-panel-header class="title">Why do you not have predictions for that exon/region?</v-expansion-panel-header>
          <v-expansion-panel-content>
            Predictions only exists for protein coding exons as annotated in the refGene database (stand July 2019).
            Make sure you selected the right species. Your sequence may contain an isoform-specific exon that is not included in the refGene database.<br>
            If you still notice that regions are missing please notify us via email to <a href="mailto:uelling@viveritatx.com">uelling@viveritatx.com</a>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header class="title">My favourite model organism is missing. What do I do?</v-expansion-panel-header>
          <v-expansion-panel-content>
            E.g. for individual genes using the UCSC genome browser you can activate tracks showing CRISPR/Cas9 target sites, pfam annotations and conservation tracks.<br>
            We may include further species in the future to request predictions please let us know via email to <a href="mailto:uelling@viveritatx.com">uelling@viveritatx.com</a>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header class="title">Do you have predictions for CRISPRa/i or nickases?</v-expansion-panel-header>
          <v-expansion-panel-content>
            No. For this application we recommend <a href="https://portals.broadinstitute.org/gpp/public/analysis-tools/sgrna-design" target="_blank">sgRNA-designer</a>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header class="title">How do I clone sgRNAs?</v-expansion-panel-header>
          <v-expansion-panel-content>
            For individual sgRNAs we recommend the GeCKO cloning protocol.
            In our data-tables for download we provide forward and reverse oligo sequences to be used for cloning.
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header class="title">Why does the Auto-pick ranking not align with VBC-Score?</v-expansion-panel-header>
          <v-expansion-panel-content>
            The VBC-Score predicts sgRNAs that have a high likelihood to generate loss of function alleles. 
            On top of that the Auto-picking mode selects against sgRNAs that are predicted to generate off-targets or for example contain a poly-T stretch (4 or more consecutive Ts) that may act as a PolIII terminator. 
            Further some sgRNAs can be cloned as 20mers, 19mers, 18mers (all with a “natural 5’ G start) or 21mers (with an additional 5’ G required for PolIII transcription). 
            The auto-selection mode slightly prefers 20meres with natural G start which performed best in our screens.<br> 
            For details see Auto-selection algorithm in the VBC-Score <a href="https://github.com/GMichlits/VBC-Score/tree/master/VBC-Score%20homepage" target="_blank">Github Repository</a>. 
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-flex>
  </v-container>
</template>

<script>
  import Logo from '../components/Logo';

  export default {
    name: 'FAQ',
    components: {
      Logo
    },
    data() {
      return {
        panel: 0
      }
    }
  }
</script>

<style scoped>

</style>